





























































































































































































































































import Vue from 'vue';
import store from '@/store';
import _ from 'lodash';
import ButtonToggle from '@/components/common/button-toggle.vue';
import { Constants } from "@/api-constants";
import { API } from "aws-amplify";
import { getModule } from "vuex-module-decorators";
import FavouritesModule from "@/store/Favourites";
import ViewpointsModule from "@/store/viewpoint/viewpoint";

export default Vue.extend({

  name: 'PropertyListing',

  components: {
    'button-toggle': ButtonToggle,
  },

  props: {
    choiceProp: {
      type: Object,
      default: {},
    },
    favouritesProp: {
      type: Array,
      default: [] as any,
    },
  },

  data() {
    return {
      dialog: false,
      choice: this.choiceProp,
      favourites: this.favouritesProp,
      erroredGet: false,
      erroredPost: false,
      packageId: this.$store.getters.getPackageId,
      factorGroupName: 'Lifestyle',
      apiFunction: '/core/selected/choices',
      changeRank: false,
    };
  },

  created() {
  },

  mounted() {
  },

  updated() {
  },

  watch: {
    dialog(newVal, oldVal) {
      if (newVal && !oldVal) {
        // Scroll the window to the top when it's opened
        setTimeout(() => document.getElementsByClassName('v-dialog--active')[0].scrollTo(0, 0), 200);
      }
    },
    choiceProp(newVal, oldVal) {
      this.choice = newVal;
    },
    favouritesProp(newVal, oldVal) {
      this.favourites = newVal;
    },
  },

  computed: {
    mailTo(): string {
      let str: string = 'mailto:info@sanostante.com?subject=MLS '
          + this.choice.name
          + ' - Requesting information on '
          + this.getPropertyValue(this.choice, 'Street Address')
          + ', '
          + this.getPropertyValue(this.choice, 'City')
          + ' - $'
          + Number(this.getPropertyValue(this.choice, 'Price')).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      let res: string = str.replace(/ /g, "%20");
      console.log(res);
      return res;
    },
    instanceId(): any {
      return getModule(ViewpointsModule).selectedViewpointId
    },
    localLogicUrl(): string {
      let lat: any = this.choice.latitude;
      let lng: any = this.choice.longitude;
      return '/local.html?lat=' + lat + '&lng=' + lng;
    },
    textSize(): string {
      switch (this.$vuetify.breakpoint.name) {
        case 'xl':
          return 'subtitle-1';
        case 'lg':
          return 'body-1';
        default:
          return '';
      }
    },
    featuresSize(): string {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'subtitle-2';
        case 'sm':
        case 'md':
          return 'subtitle-1';
        default:
          return 'title';
      }
    },
    addressSize(): string {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'subtitle-1';
        default:
          return 'headline';
      }
    },
    priceSize(): string {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'headline';
        default:
          return 'display-1';
      }
    },
    titleSize(): string {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'title';
        default:
          return 'headline';
      }
    },
  },

  methods: {

    isFavourite(choiceId: string): boolean {
      return this.favourites.includes(choiceId);
    },

    async addFavourite(choiceId: string) {
      await getModule(FavouritesModule).addFavourite(choiceId)

    },

    async removeFavourite(choiceId: string) {
      await getModule(FavouritesModule).removeFavourite(choiceId)
    },

    formatDate(dateString: string): string {
      let newDate: Date = new Date(dateString);
      let options: object = {year: 'numeric', month: 'long', day: 'numeric'};
      let locale: string = 'en-US';
      return newDate.toLocaleDateString(locale, options);
    },

    getPropertyValue(choice: any, name: string): any {
      return choice[_.camelCase(name)]
    },

    formatNumber(value: number, digits: number = 0): number {
      if (digits < 0) digits = 0;
      var formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: digits,
      });
      return Number(formatter.format(value));
    },

  },

});

